export enum TraceEventName {
    PAGE_INITIAL = 'PAGE_INITIAL_RENDER',
    PAGE_RENDER_KBA = 'PAGE_RENDER_KBA',
    PAGE_RENDER_PERSONAL_DATA = 'PAGE_RENDER_PERSONAL_DATA',
    PAGE_RENDER_LEGAL_PERSONAL_DATA = 'PAGE_RENDER_LEGAL_PERSONAL_DATA',
    PAGE_RENDER_BIOMETRY = 'PAGE_RENDER_BIOMETRY',
    PAGE_RENDER_OTP_GET_CODE = 'PAGE_RENDER_OTP_GET_CODE',
    PAGE_RENDER_OTP_VALIDATION_CODE = 'PAGE_RENDER_OTP_VALIDATION_CODE',
    PAGE_RENDER_ACCOUNT_DATA = 'PAGE_RENDER_ACCOUNT_DATA',
    PAGE_RENDER_SUCCESS = 'PAGE_RENDER_SUCCESS',
    PAGE_DATA_COLLECTION = 'PAGE_DATA_COLLECTION',


    ACTION_INITIAL = 'ACTION_INITIAL',
    ACTION_PERSONAL_DATA = 'ACTION_PERSONAL_DATA',
    ACTION_OTP_GET_CODE = 'ACTION_OTP_GET_CODE',
    ACTION_OTP_RETRY_GET_CODE = 'ACTION_OTP_RETRY_GET_CODE',
    ACTION_OTP_VALIDATION_CODE = 'ACTION_OTP_VALIDATION_CODE',
    ACTION_LEGAL_PERSONAL_DATA = 'ACTION_LEGAL_PERSONAL_DATA',
    ACTION_ACCOUNT_DATA = 'ACTION_ACCOUNT_DATA',
  }
